import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import UserPanelTitle from '../UserPanelTitle/UserPanelTitle'
import './UserPanelEditInfo.css'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

export default function UserPanelEditInfo() {
    const nav =useNavigate();
    const [user, setUser] = useState({
        imageFile: null,
        bio: '',
        lastName: '',
        firstName: '',
        username: '',
        email: '',
        phoneNumber: null,
        password: null,
        confirmPassword: null,
    });

    useEffect(() => {
        axiosConfig.get("api/user").then((res) => {
            setUser(res.data);
        })
    }, [])

    function handleFileChange(event) {
        setUser({ ...user, imageFile: event.target.files[0] })
    }

    function sendData() {
        if (user.password != user.confirmPassword) {
            Swal.fire(
                {
                    icon: 'error',
                    text: "رمز عبور با تکرار رمز عبور یکسان نیست",
                    confirmButtonText: "بله"
                }
            )
        } else if (user.username == '' || user.phoneNumber == null) {
            Swal.fire(
                {
                    icon: 'error',
                    text: "لطفا مقادیر را ب درستی پر کنید",
                    confirmButtonText: "بله"
                }
            )
        } else {
            axiosConfig
                .put("/api/user", user, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    Swal.fire({
                        title: res.data.message,
                        icon: "success",
                        confirmButtonText: "تایید",
                    });
                    nav("/userpanel")
                })
                .catch((res) => {
                    Swal.fire({
                        title: res.response.data.message,
                        icon: "error",
                        confirmButtonText: "تایید",
                    });
                });
        }
    }
    return (
        <>
            <div className='userpanel-edit'>
                <h2 className='userpanel-edit-title'>تغییر اطلاعات کاربری</h2>
                <Row>
                    <Col md='12' lg='6'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                نام
                            </label>
                            <input value={user?.firstName} onChange={(e) => setUser({ ...user, firstName: e.target.value })} type="text" placeholder='نام خود را وارد کنید' />
                        </div>
                    </Col>
                    <Col md='12' lg='6'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                نام خانوادگی
                            </label>
                            <input value={user?.lastName} onChange={(e) => setUser({ ...user, lastName: e.target.value })} type="text" placeholder='نام خانوادگی ' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                پروفایل انتخاب کنید
                            </label>
                            <input onChange={handleFileChange} type="file" className='file-input' name="myImage" />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                نام کاربری
                            </label>
                            <input value={user?.username} onChange={(e) => setUser({ ...user, username: e.target.value })} type="text" placeholder='نام کاربری را وارد کنید' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                بیوگرافی
                            </label>
                            <input value={user?.bio} onChange={(e) => setUser({ ...user, bio: e.target.value })} type="text" placeholder='بیوگرافی خود را بنویسید' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                شماره موبایل
                            </label>
                            <input value={user?.phoneNumber} onChange={(e) => setUser({ ...user, phoneNumber: e.target.value })} type="text" placeholder='شماره موبایل خود را بنویسید' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                رمز عبور جدید
                            </label>
                            <input value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} type="text" placeholder=' رمز عبور جدید' />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12'>
                        <div className='userpanel-edit-box'>
                            <label htmlFor="">
                                <UserPanelTitle />
                                تکرار رمز عبور
                            </label>
                            <input value={user.confirmPassword} onChange={(e) => setUser({ ...user, confirmPassword: e.target.value })} type="text" placeholder='تکرار رمز عبور ' />
                        </div>
                    </Col>
                </Row>
                <div className='userpanel-edit-btn'>
                    <button onClick={() => sendData()} className='userpanel-edit-button'>تغییر اطلاعات</button>
                </div>
            </div>
        </>
    )
}